"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _util = require("../../util");
var bem = (0, _util.bemClass)('revision-offers');
var InvalidOffer = function InvalidOffer(_ref) {
  var minimumAmount = _ref.minimumAmount,
    maximumAmount = _ref.maximumAmount,
    productTerm = _ref.productTerm;
  return /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": "invalid-offer",
    className: bem('invalid-offer')
  }, /*#__PURE__*/_react.default.createElement("input", {
    type: "radio",
    className: bem('invalid-offer', 'invalid-offer-radio'),
    disabled: true
  }), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement("strong", null, "Min ", minimumAmount)), "-", /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement("strong", null, "Max ", maximumAmount), " for ", productTerm, " months")));
};
InvalidOffer.propTypes = {
  minimumAmount: _propTypes.default.string.isRequired,
  maximumAmount: _propTypes.default.string.isRequired,
  productTerm: _propTypes.default.string.isRequired
};
var _default = InvalidOffer;
exports.default = _default;
